import Color from "color";

export const ColorAA = {
  violet: "#8800ff",
  pink: "#ff216e",
  black: "#000",
  yellow: "#e3fc26",
  beige: "#ededd9",
  blue: "#0600ff",
  turquoise: "#00e1ff",
  lightBlack: "#1c1c1c",
  lightBeige: "#f5f6eaff",
  lightGrey: "lightgrey",
  grey: "grey",
  white: "white",
};

const DEFAULT_DATASET_COLORS_LIGHT = [
  ColorAA.turquoise,
  ColorAA.violet,
  ColorAA.blue,
  "orange",
  "green",
];

const DEFAULT_DATASET_COLORS_DARK = [
  ColorAA.yellow,
  ColorAA.turquoise,
  ColorAA.violet,
  ColorAA.blue,
  "orange",
  "green",
];

export const getColorsForDataset = (
  index: number,
  isDarkMode: boolean
): {
  borderColor: string;
  backgroundColor: string;
  borderWidth: number;
  borderSkipped: "middle";
} => {
  const palette = isDarkMode
    ? DEFAULT_DATASET_COLORS_DARK
    : DEFAULT_DATASET_COLORS_LIGHT;
  const baseColor = palette[index % palette.length];
  return {
    borderColor: Color(baseColor).alpha(1.0).hexa(),
    backgroundColor: Color(baseColor)
      .alpha(1 - Math.pow(0.5, 1 + Math.floor(index / palette.length)))
      .hexa(),
    borderWidth: 2,
    borderSkipped: "middle",
  };
};
